import { render } from "./messages.vue?vue&type=template&id=62358e8b&scoped=true&lang=pug"
import script from "./messages.vue?vue&type=script&lang=js"
export * from "./messages.vue?vue&type=script&lang=js"

import "./messages.vue?vue&type=style&index=0&id=62358e8b&lang=scss&scoped=true"

import exportComponent from "../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62358e8b"]])

export default __exports__